import { Text } from '../cdl/Text/Text';
import { translate } from '../common/helpers/translate.helper';
import { useDocumentTitle } from '../common/hooks/useDocumentTitle';
import { useRole } from '../common/hooks/useRole';
import { Page } from '../common/Page/Page';
import { PageGrid } from '../common/PageGrid';
import { Section } from '../common/Section/Section';
import { Box } from '../common/ui/Box';

import { QuickStats } from './common/components/QuickStats';
import { UpdateSection } from './common/components/UpdateSection';
import { WelcomePopup } from './common/components/WelcomePopup';
import { ApprovalRequestTable } from './components/ApprovalRequestTable';
import { CustomerOrderTable } from './components/CustomerOrderTable';
import { SupplierDashboardRfqTable } from './components/SupplierDashboardRfqTable';
import { SuperAdminDashboard } from './SuperAdminDashboard';

const TableSection = () => {
    const role = useRole();

    if (role.isSuperAdmin()) {
        return null;
    }

    if (role.isCustomer()) {
        return (
            <Box>
                <ApprovalRequestTable />
                <CustomerOrderTable />
            </Box>
        );
    }

    if (role.isSupplier()) {
        return <SupplierDashboardRfqTable />;
    }

    return null;
};

export const Dashboard = () => {
    const role = useRole();
    useDocumentTitle(translate('page.dashboardoverview'));

    if (role.isSuperAdmin()) {
        return (
            <Page>
                <SuperAdminDashboard />
            </Page>
        );
    }

    return (
        <Page>
            <PageGrid>
                <Box display="flex">
                    <Text marginRight={8} variant="headline" as="h1">
                        {translate('dashboard.headline')}
                    </Text>
                </Box>

                <UpdateSection />

                <Section title={translate('dashboard.quickstats.headline')} paddingY={0}>
                    <QuickStats />
                </Section>

                <TableSection />
            </PageGrid>
            <WelcomePopup />
        </Page>
    );
};
